export const Colors = {
  primary: "#1bbc9b",
};
